import useFilterFormContext from 'components/filters/useFilterFormContext';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import LeadSearchField from 'components/forms/domain/lead/LeadSearchField';
import { ScheduledMessagesTabFiltersSchemaType } from '../ScheduledMessagesTabFilters.schema';

const LeadsField = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<ScheduledMessagesTabFiltersSchemaType>();
  const { searchFieldRef, setLastSubmittedFilters } =
    useFilterFormContext<ScheduledMessagesTabFiltersSchemaType>();

  return (
    <LeadSearchField
      align="right"
      name="leads"
      colSmInput={12}
      placeholder={t('form.guestNameEmail')}
      containerClassName="search-field"
      instanceRef={searchFieldRef}
      withMessages="SCHEDULED_MESSAGES"
      onChange={(options) => {
        const values = getValues();
        setLastSubmittedFilters({
          ...values,
          leads: options as never,
        });
      }}
    />
  );
};

export default LeadsField;
